/**
 * Guards para consultas de red.
 *
 * Motivo: si una conexión se corta a nivel de transporte (p. ej. net::ERR_CONNECTION_CLOSED),
 * la promesa de fetch puede quedarse pendiente y un bloque `finally` nunca se ejecuta.
 * Eso deja pantallas de carga infinitas.
 *
 * Estas utilidades NO modifican las consultas: solo garantizan que la espera termine.
 */

export const DASHBOARD_QUERY_TIMEOUT_MS = 12000;

export const QUERY_TIMEOUT_MESSAGE = 'QUERY_TIMEOUT';

/**
 * Resuelve o rechaza la promesa en un tiempo máximo.
 * No cancela la petición subyacente, solo libera la UI.
 */
export function withDeadline<T>(
  promise: Promise<T>,
  timeoutMs: number = DASHBOARD_QUERY_TIMEOUT_MS,
  message: string = QUERY_TIMEOUT_MESSAGE,
): Promise<T> {
  return new Promise<T>((resolve, reject) => {
    const timer = setTimeout(() => {
      reject(new Error(message));
    }, timeoutMs);

    promise.then(
      (value) => {
        clearTimeout(timer);
        resolve(value);
      },
      (error) => {
        clearTimeout(timer);
        reject(error);
      },
    );
  });
}